module.exports = __webpack_public_path__ + "static/img/5.98f037e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/add/5.png
// module id = iaLu
// module chunks = 1